export default "__VITE_ASSET__BrIEtt8B__"